import Login from "@/views/Login";
import {isAuthUser} from "@/helper/permissionHelper";


export default [
    {
        path: "/login",
        name: "Login",
        component: Login,
        meta: {
            requiresAuth: false
        },
        beforeEnter: (to, from, next) => {
            if (isAuthUser()) {
                return next({
                    name: 'Dashboard'
                });
            }
            next();
        },
    },
];
